import { render, staticRenderFns } from "./cg-event-bands-support.vue?vue&type=template&id=06c62ea4&scoped=true"
import script from "./cg-event-bands-support.vue?vue&type=script&lang=js"
export * from "./cg-event-bands-support.vue?vue&type=script&lang=js"
import style0 from "./cg-event-bands-support.vue?vue&type=style&index=0&id=06c62ea4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c62ea4",
  null
  
)

export default component.exports